import * as ngCore from '@angular/core'
import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'
import * as featureFlags from '@attain-apps/feature-flags'

import * as content from '../content'

import * as toaster from './toaster'
import * as writingHelper from './writing-helper'

/**
 * Things that float on the screen (often conditionally) from anywhere in the
 * platform
 */
@ngCore.Component({
  imports: [
    clipboard.overlay.Component,
    content.summit.checkInWizard.Component,
    toaster.Component,
    writingHelper.Component,
  ],
  selector: 'atn-platform-floaters',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link featureFlags.FeatureFlags} */
  public readonly featureFlags = featureFlags.get()
}
